import React, { FC } from "react";
import { useDropzone, FileWithPath } from "react-dropzone";
import styled from "styled-components";
import { FaEdit } from "react-icons/fa";

interface DragNDropImageProps {
    setFiles?: (files: FileWithPath[]) => void;
    style?: React.CSSProperties;
    backgroundImg?: string;
}

const StyledDropzone = styled.div`
  border: 2px dashed #ddd;
  border-radius: 5px;
  cursor: pointer;
  min-height: 150px;
  padding: 20px 40px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const DragNDropImage: FC<DragNDropImageProps> = ({
    setFiles,
    style = {},
    backgroundImg,
}) => {
    const { getRootProps, getInputProps } = useDropzone({
        onDrop: (acceptedFiles: FileWithPath[]) => {
            setFiles?.(acceptedFiles);
        },
        multiple: false,
    });

    return (
        <StyledDropzone
            style={{
                position: "relative",
                width: "100%",
                height: "300px",
                overflow: "hidden",
                zIndex: 0,
                ...style,
            }}
            {...getRootProps({ className: "dropzone" })}
        >
            {backgroundImg && (
                <img
                    src={backgroundImg}
                    alt="preview"
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        zIndex: -1,
                    }}
                />
            )}
            <input {...getInputProps()} />

            {backgroundImg && (
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.2)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1,
                    }}
                >
                    <FaEdit color="#fff" size="40" />
                </div>
            )}

            {backgroundImg ? <p>Change Image</p> : <p>Drag and drop image here or click to select image</p>}
        </StyledDropzone>
    );
};

export default DragNDropImage;
